module.exports = __webpack_public_path__ + "static/media/expected-position-icon1.cca390a7.png";